import { UseStore } from '@eastcoal/common/types/zustand'
import { useContextStore } from '@eastcoal/common/utils/zustand'

import { AuctionListStoreContext } from '../contexts/StoreContext'
import { AuctionListStore } from '../store/interface'

export const useAuctionListStore: UseStore<AuctionListStore> = selector => {
  return useContextStore(AuctionListStoreContext, selector)
}
